import http from '../../api';

export default async function (objectType, objectId, objectGeometryId) {
  try {
    const response = await http.get(`admin/layer-objects/${objectId}/geometries/${objectGeometryId}`);
    return response;
  } catch (e) {
    console.error(e);
    throw e;
  }
}
